import { useState } from 'react';
import { RfNodeGroup, SweepCanvasRfNode } from './canvas-types/nodeTypesData';

import { getViewportForBounds } from '@xyflow/react';
import { CanvasElementType } from './canvas-types';

export const useCalculateInitialViewport = (nodes: SweepCanvasRfNode[], minZoom: number) => {
  const [initialViewport] = useState(() => {
    const groupNodes = nodes.filter(
      (node) => node.type === CanvasElementType.GROUP,
    ) as RfNodeGroup[];
    const bounds = groupNodes.reduce(
      (acc, node) => {
        const nodeBoundingBox = node.data.boundingBox;
        return {
          x: Math.min(acc.x, acc.x),
          y: Math.min(acc.y, acc.y),
          width: Math.max(acc.width, nodeBoundingBox.marginLeft + nodeBoundingBox.width),
          height: Math.max(acc.height, nodeBoundingBox.marginTop + nodeBoundingBox.height),
        };
      },
      { x: 0, y: 0, width: 0, height: 0 },
    );

    // @ts-ignore: Expected 6 arguments, but got 5
    return getViewportForBounds(bounds, window.innerWidth, window.innerHeight, minZoom, 1);
  });

  return initialViewport;
};
